import { localizeHref } from "@/paraglide/runtime";
// 需要登录才能访问的路由
export const AUTH_ROUTES = [
	"/profile",
	"/profile/account",
	"/profile/comment",
	"/profile/creation",
	"/profile/deposit",
	"/profile/gem",
	"/profile/invite",
] as const;

// 路由类型
export type AuthRoute = (typeof AUTH_ROUTES)[number];

// 检查路由是否需要登录
export const isAuthRoute = (pathname: string): boolean => {
	return AUTH_ROUTES.some((route) => pathname.startsWith(localizeHref(route)));
};
